<template>
  <div class="w-2-5 flex ac je background-deep tool">
    <el-popover popper-class="el-p no-drag" placement="bottom" trigger="hover" ref="plang" v-model="visible">
      <span slot="reference" class="text-foreground no-drag">
        {{ $t("tool.lang") }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <div>
        <div class="po text-sm py-1-5 px-2 el-div flex ac" @click="changeLang('zh-CN')">
          <span :class="{ 'el-icon-location': $store.getters['app/getLang'] == 'zh-CN' }"></span>
          中文
        </div>
        <div class="po text-sm py-1-5 px-2 el-div flex ac" @click="changeLang('en-US')">
          <span :class="{ 'el-icon-location': $store.getters['app/getLang'] == 'en-US' }"></span>
          English
        </div>
      </div>
    </el-popover>
    <el-popover popper-class="el-p no-drag flex ac" trigger="hover" placement="bottom" v-if="user">
      <span slot="reference" class="no-drag">
        <span class="el-icon-user f18"></span>{{ user.username }}
      </span>
      <div style="width: 100%">
        <div class="po text-sm py-1-5 px-2 el-div2" @click="logout">
          <span>{{ $t("tool.logout") }}</span>
        </div>
      </div>
    </el-popover>
    <span class="el-icon-remove-outline f24 no-drag" @click="min"></span>
    <span class="el-icon-copy-document f24 no-drag" @click="changeSize"></span>
    <span class="el-icon-circle-close f24 no-drag" @click="close"></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  props: {
    user: {
      type: [Object, Boolean],
      default: () => {
        return false;
      },
    },
  },
  created() { },
  methods: {
    changeLang(lang) {
      this.$store.commit("app/changeLang", lang);
      this.visible = false;
    },
    logout() {
      this.$eapi
        .invoke("system:session-event", {
          action: "delUser",
        })
        .then(() => {
          this.$router.push({
            name: "app_login",
          });
        });
    },
    min() {
      this.$eapi
        .invoke("system:win-event", {
          action: "minWin",
        })
        .then((rs) => {
          // console.log("=================system:win-event", rs);
        });
    },
    changeSize() {
      this.$eapi
        .invoke("system:win-event", {
          action: "maxMinWin",
        })
        .then((rs) => {
          // console.log("=================system:win-event", rs);
        });
    },
    close() {
      this.$eapi
        .invoke("system:win-event", {
          action: "closeWin",
        })
        .then((rs) => {
          // console.log("=================system:win-event", rs);
        });
    },
  },
};
</script>
